<template>
    <div>
        <LandingSlide />
        <SearchBar />
        <ProductSalesSlide :isCamping="false" />
        <LandingTypes />
        <LandingValues />
        <LandingBannerMiddle />
        <LandingAbout />
        <Clubs :isCamping="false" />
        <LandingNews />
    </div>
</template>

<script>
import LandingSlide from "@/components/LandingSlide";
import SearchBar from "@/components/SearchBar";
import ProductSalesSlide from "@/components/ProductSalesSlide";
import LandingTypes from "@/components/LandingTypes";
import LandingValues from "@/components/LandingValues";
import LandingBannerMiddle from "@/components/LandingBannerMiddle";
import LandingAbout from "@/components/LandingAbout";
import Clubs from "@/components/Clubs";
import LandingNews from "@/components/LandingNews";
import { mapState, mapActions } from "vuex";
import { get } from "lodash";
import { setDescriptionPage } from "@/helper/helper";
export default {
    name: "LandingPage",
    components: {
        LandingSlide,
        SearchBar,
        ProductSalesSlide,
        LandingTypes,
        LandingValues,
        LandingBannerMiddle,
        LandingAbout,
        Clubs,
        LandingNews
    },
    mounted() {
        this.getLandingPage();
        this.getCategories();
        this.getCampingClubs();
        this.getTypes();
        this.getNewsHome();
        setDescriptionPage(get(this.landingPage, "meta_description"));

        // this.getPromotions();
    },
    computed: {
        ...mapState({
            landingPage: state => get(state, "app.landingPage", {}),
            general: state => get(state, "app.general", {})
        })
    },
    methods: {
        ...mapActions("app", ["getLandingPage", "getNewsHome"]),
        ...mapActions("categories", ["getCategories"]),
        ...mapActions("types", ["getTypes"]),
        ...mapActions("campingClubs", ["getCampingClubs"])
        // ...mapActions("hotels", ["getPromotions"])
    }
};
</script>
